<script setup lang="ts">
import type { AlertProps } from '#ui/types';

import type { InspectionReminderType } from '~/types/saleStatus';

// PROPS
interface Props {
    reminder: InspectionReminderType;
    variant?: AlertProps['variant'];
}

const { variant = 'subtle' } = defineProps<Props>();
</script>

<template>
    <UAlert color="warning" :variant="variant" icon="lucide:triangle-alert">
        <template #description>
            <BaseI18nHtml :keypath="`sdp.notice.inspectionReminder.${reminder}`" tag="p" />
        </template>
    </UAlert>
</template>
